import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Logo Icons
const GoogleAdsIcon = ({
  className,
  size = 16,
  x,
  y,
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={`icon-google-ads${className ? ` ${className}` : ""}`}
    size={size}
    aria-label={ariaLabel}
    viewBox="0 0 16 16"
    x={x}
    y={y}
  >
    <title>Google Ads</title>
    <path
      d="M6.08353 3.88058C6.19952 3.57612 6.359 3.29582 6.5958 3.06868C7.54303 2.14562 9.10885 2.37759 9.75161 3.53746C10.2349 4.41702 10.7472 5.27726 11.2449 6.14716C12.0762 7.59216 12.9171 9.03716 13.7387 10.487C14.4297 11.7 13.6807 13.232 12.3082 13.4398C11.4672 13.5655 10.6795 13.1789 10.2446 12.4249C9.5148 11.1539 8.78022 9.8829 8.05047 8.61671C8.03597 8.58771 8.01664 8.56355 7.99731 8.53938C7.91999 8.47656 7.88616 8.38474 7.83783 8.30258C7.51403 7.73231 7.18057 7.16687 6.85677 6.60144C6.64897 6.23415 6.43149 5.87169 6.22368 5.5044C6.0352 5.17577 5.94821 4.81814 5.95788 4.44119C5.97238 4.24788 5.99654 4.05456 6.08353 3.88058Z"
      fill="var(--color-brand-google-ads-1)"
      id="icon-logo-1-fill"
    />
    <path
      d="M6.08361 3.88058C6.04011 4.05456 6.00145 4.22854 5.99178 4.41219C5.97729 4.81814 6.07877 5.1951 6.28175 5.54789C6.81336 6.46129 7.34496 7.37952 7.87174 8.29775C7.92006 8.3799 7.95872 8.46206 8.00705 8.53939C7.71709 9.042 7.42712 9.53977 7.13232 10.0424C6.72637 10.7431 6.32041 11.4487 5.90963 12.1495C5.8903 12.1495 5.88546 12.1398 5.88063 12.1253C5.8758 12.0866 5.8903 12.0528 5.89996 12.0142C6.0981 11.2892 5.93379 10.6465 5.43601 10.0955C5.13155 9.76208 4.74493 9.5736 4.30031 9.51078C3.72038 9.42862 3.2081 9.57843 2.74899 9.94089C2.66683 10.0037 2.61367 10.0955 2.51701 10.1439C2.49768 10.1439 2.48802 10.1342 2.48318 10.1197C2.71516 9.71858 2.9423 9.31746 3.17427 8.91634C4.13116 7.25387 5.08805 5.59139 6.04978 3.93375C6.05944 3.91441 6.07394 3.89992 6.08361 3.88058Z"
      fill="var(--color-brand-google-ads-2)"
      id="icon-logo-2-fill"
    />
    <path
      d="M2.5025 10.1342C2.59433 10.052 2.68132 9.965 2.77797 9.88768C3.95234 8.95979 5.7163 9.63154 5.97244 11.1007C6.03526 11.4535 6.00144 11.7918 5.89511 12.1301C5.89028 12.1591 5.88545 12.1833 5.87578 12.2122C5.83229 12.2896 5.79363 12.3717 5.7453 12.4491C5.31518 13.1595 4.68209 13.5123 3.85085 13.4591C2.89879 13.3914 2.14971 12.6762 2.01922 11.729C1.9564 11.2699 2.04822 10.8397 2.28503 10.4435C2.33335 10.3565 2.39135 10.2791 2.44451 10.1921C2.46867 10.1728 2.45901 10.1342 2.5025 10.1342Z"
      fill="var(--color-brand-google-ads-3)"
      id="icon-logo-3-fill"
    />
    <path
      d="M2.50252 10.1341C2.48319 10.1534 2.48319 10.1872 2.44936 10.1921C2.44453 10.1582 2.46386 10.1389 2.48319 10.1147L2.50252 10.1341Z"
      fill="var(--color-brand-google-ads-2)"
      id="icon-logo-2-fill"
    />
    <path
      d="M5.87571 12.2123C5.85638 12.1785 5.87571 12.1543 5.89504 12.1302C5.89988 12.135 5.90954 12.1447 5.91438 12.1495L5.87571 12.2123Z"
      fill="var(--color-brand-google-ads-2)"
      id="icon-logo-2-fill"
    />
  </OpticksSvgElement>
);

export default GoogleAdsIcon;
